import naral7_1 from "./naravillage7-01-1200x800-1.webp";

const naral7 = [naral7_1];

export default naral7;
